import { getEnvs } from "state/EnvironmentsContext/EnvContext";
import { useOrgData } from "state/OrgDataContext";
import { useFeatureFlag } from "state/featureFlags";
import FEATURE_FLAGS from "state/featureFlags/flags";
import useEventRouting from "hooks/useEventRouting";
import { useEventTheming } from "state/AppThemingContext";
import { useMemo } from "react";
/**
 * Hook to get processed event assets with src URLs
 * This replaces the old static import approach
 */
export const useAppAssetsWithSrc = () => {
  const { dataAssets: applicationEventAssets } = useOrgData();
  const isEventThemingEnabled = useFeatureFlag(FEATURE_FLAGS.eventTheming);
  const { eventId } = useEventRouting();
  const { theming } = useEventTheming();

  const AppThemingAssets = useMemo(()=> (
  {  
    "logo":theming?.logos?.logo_light,
    "favIcon":theming?.favicon,
    "logoDark":theming?.logos?.logo_dark,
    
    "eventPlaceholder":theming?.assets?.placeholder,
    "login_BG_mobile":theming?.assets?.login_background,
    "login_BG_desktop":theming?.assets?.login_background,
    "login_BG_mobileDark":theming?.assets?.login_background,
    "login_BG_desktopDark":theming?.assets?.login_background,

    "choices_BG_mobile":theming?.assets?.choices_background,
    "choices_BG_desktop":theming?.assets?.choices_background,
    "choices_BG_desktopDark":theming?.assets?.choices_background,
    "choices_BG_mobileDark":theming?.assets?.choices_background,
    
    "alldone_BG_mobile":theming?.assets?.all_done_background,
    "alldone_BG_desktop":theming?.assets?.all_done_background,
    "alldone_BG_mobileDark":theming?.assets?.all_done_background,
    "alldone_BG_desktopDark":theming?.assets?.all_done_background,
    })
  ,[theming]);
  
  // get and mutate the host name
  const EVENT_CLOUDINARY_PRESET =
    getEnvs((state) => state.cloudinary_preset) ||
    getEnvs((state) => state.cloudinary_cloud_name) ||
    "blinkapp";

  const hostname = window.location.hostname;
  const domain = hostname.split(".")[0] || hostname;

  const domainName =
    window._env_?.REACT_APP_DOMAIN_NAME ||
    getEnvs((state) => state.domain_name) ||
    domain;

  const EVENT_DOMAIN_NAME =
    getEnvs((state) => state.api_service) === "heroku"
      ? getEnvs((state) => state.domain_name)
      : domainName;
  const CLOUDINARY_BASE = `https://res.cloudinary.com/${EVENT_CLOUDINARY_PRESET}/image/upload/`;

  const AppAssetsWithSrc = Object.fromEntries(
    Object.entries(applicationEventAssets).map(([key, asset]) => {
    
      const pathname = isEventThemingEnabled
        ? `/events/${eventId}${asset?.pathname}`
        : asset?.pathname;

      const assetWithSrc = {
        ...asset,
        src: isEventThemingEnabled ? AppThemingAssets[key] : `${CLOUDINARY_BASE}${EVENT_DOMAIN_NAME}/${asset.folder}${pathname}`,
      };
      return [key, assetWithSrc];
    }),
  );
  return AppAssetsWithSrc;
};
